export const EmergencyContactImages = {
  successContact: require('./successContact.svg'),
  errorContact: require('./errorContact.svg'),
};
